import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Cursor } from "./Cursor";

function ScrollTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}

export function Layout({ children }) {
  return (
    <div className="grain relative min-h-screen bg-obsidian">
      <ScrollTop />
      <Cursor />
      <Header />
      <main className="relative z-10">{children}</main>
      <Footer />
    </div>
  );
}
